import { useState } from "react";
import { X, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { useUserData } from "../context/UserDataContext";

export default function NoteDialog({ item, onClose, onSaved }) {
  const { notes, saveNote } = useUserData();
  const [text, setText] = useState(notes[item.id] || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      await saveNote(item.id, text);
      toast.success(text.trim() ? "Note saved" : "Note removed");
      onSaved?.();
      onClose();
    } catch { toast.error("Could not save note"); }
    finally { setBusy(false); }
  };

  const remove = async () => {
    setBusy(true);
    try {
      await saveNote(item.id, "");
      toast.success("Note removed");
      onSaved?.();
      onClose();
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[80] bg-ink/90 backdrop-blur-sm flex items-start justify-center overflow-y-auto py-16 px-6" data-lenis-prevent onClick={onClose}>
      <div className="w-full max-w-lg bg-ink-800 border border-line p-8" onClick={(e) => e.stopPropagation()} data-testid="note-dialog">
        <div className="flex justify-between items-start mb-6">
          <div>
            <p className="overline text-crimson mb-2">Private note</p>
            <h3 className="font-serif text-2xl text-vellum leading-tight">{item.title}</h3>
            <p className="font-mono text-xs text-vellum-faint mt-1">{item.creator}</p>
          </div>
          <button onClick={onClose} aria-label="Close"><X className="w-5 h-5 text-vellum-muted hover:text-onaccent" /></button>
        </div>
        <textarea
          data-testid="note-textarea"
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={6}
          autoFocus
          placeholder="What do you want to remember about this?"
          className="w-full bg-transparent border border-line px-4 py-3 text-vellum font-sans text-sm leading-relaxed focus:border-crimson focus:outline-none placeholder:text-vellum-faint resize-none"
        />
        <div className="mt-6 flex items-center gap-4">
          <button onClick={save} disabled={busy} data-testid="note-save" className="font-mono text-xs uppercase tracking-[0.2em] px-6 py-3 bg-vellum text-ink hover:bg-crimson hover:text-onaccent transition-colors disabled:opacity-50">Save note</button>
          {notes[item.id] && (
            <button onClick={remove} disabled={busy} className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-vellum-muted hover:text-crimson transition-colors">
              <Trash2 className="w-3.5 h-3.5" /> Delete
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
